import React from "react"
import ReactApexChart from "react-apexcharts"

const DonutChart = ({
	data,
	labels,
	title,
	className = "",
	colors = ["#6955EA", "#AEA2FF", "#352D66", "#F4F8FD", "#1a1633"], // Using your existing color scheme
	width = "100%",
	height = 350,
	customOptions = {}
}) => {
	// Default options
	const defaultOptions = {
		chart: {
			type: "donut",
			fontFamily: "Manrope, sans-serif",
			toolbar: {
				show: false
			}
		},
		labels: labels || [],
		colors: colors || ["#6955EA", "#AEA2FF", "#352D66", "#F4F8FD", "#1a1633"],
		legend: {
			show: false // Completely disable the legend
		},
		dataLabels: {
			enabled: true,
			formatter: function (val, opts) {
				return val.toFixed(1) + "%"
			},
			style: {
				fontSize: "12px",
				fontFamily: "Manrope, sans-serif",
				colors: ["#fff"],
				textOutline: "none"
			},
			background: {
				enabled: false
			},
			dropShadow: {
				enabled: false
			}
		},
		tooltip: {
			y: {
				formatter: function (val) {
					return val
				}
			}
		},
		responsive: [
			{
				breakpoint: 480,
				options: {
					chart: {
						width: 200
					},
					legend: {
						show: false // Also ensure legend is hidden at mobile breakpoints
					}
				}
			}
		],
		stroke: {
			width: 2,
			colors: ["#fff"]
		},
		plotOptions: {
			pie: {
				donut: {
					size: "55%",
					labels: {
						show: false,
						name: {
							show: true,
							fontSize: "16px",
							fontFamily: "Manrope, sans-serif",
							color: "#352D66"
						},
						value: {
							show: true,
							fontSize: "22px",
							fontFamily: "Manrope, sans-serif",
							color: "#352D66"
						},
						total: {
							show: false
						}
					}
				}
			}
		}
	}

	// Merge default options with custom options
	const options = {
		...defaultOptions,
		...customOptions,
		// Ensure these specific nested properties are properly merged
		chart: { ...defaultOptions.chart, ...(customOptions.chart || {}) },
		// Always force legend to be hidden, even if custom options try to show it
		legend: { show: false, ...(customOptions.legend || {}) },
		dataLabels: {
			...defaultOptions.dataLabels,
			...(customOptions.dataLabels || {}),
			style: {
				...defaultOptions.dataLabels.style,
				...(customOptions.dataLabels?.style || {}),
				textOutline: "none"
			},
			dropShadow: {
				enabled: false
			}
		},
		plotOptions: {
			...defaultOptions.plotOptions,
			...(customOptions.plotOptions || {}),
			pie: {
				...defaultOptions.plotOptions?.pie,
				...(customOptions.plotOptions?.pie || {}),
				donut: {
					...defaultOptions.plotOptions?.pie?.donut,
					...(customOptions.plotOptions?.pie?.donut || {})
				}
			}
		}
	}

	return (
		<>
			<ReactApexChart
				options={options}
				series={data}
				type="donut"
				width={width}
				height={height}
			/>
		</>
	)
}

export default DonutChart
